import { createStructuredSelector } from 'reselect';

import { fetchGAWState } from './LoadingPageSelectors';
import { selectAccountData } from './AgreementFlowSelectors';
import {
  selectAdvisors,
  mapData,
  selectCsrBusinessFunction,
} from '../../../../../selectors/globalSelectors';



export const selectDataAccountName = (state) => {
  const { accountData } = fetchGAWState(state);
  if (accountData && accountData.data && accountData.data.accountName) {
    return accountData.data.accountName;
  }
  return '';
};

export const selectEditAndReviewCharityAddress = (state) => {
  const { selectedCharityAddress } = fetchGAWState(state);
  return selectedCharityAddress;
};

export const selectEditAndReviewCharityName = (state) => {
  const { selectedCharityName } = fetchGAWState(state);
  return selectedCharityName;
};

export const selectEditAndReviewGranteeOrgFirstName = (state) => {
  const { granteeOrgFirstName } = fetchGAWState(state);
  return granteeOrgFirstName;
};

export const selectEditAndReviewGranteeOrgLastName = (state) => {
  const { granteeOrgLastName } = fetchGAWState(state);
  return granteeOrgLastName;
};

export const selectGranteeOrgEmailAddress = (state) => {
  const { granteeOrgEmailAddr } = fetchGAWState(state);
  return granteeOrgEmailAddr;
};

export const selectEditAndReviewPermissionToPublish = (state) => {
  const { permissionToPublish } = fetchGAWState(state);
  return permissionToPublish;
};

export const selectGranteeOrgPhoneNo = (state) => {
  const { granteeOrgPhoneNumber } = fetchGAWState(state);
  return granteeOrgPhoneNumber;
};

export const selectPurpose = (state) => {
  const { purpose } = fetchGAWState(state);
  return purpose;
};

export const selectGrantRecognition = (state) => {
  const { grantRecognition } = fetchGAWState(state);
  return grantRecognition;
};

export const selectInvestmentPools = (state) => {
  const { accountData } = fetchGAWState(state);
  if (accountData && accountData.data && accountData.data.investmentPools) {
    return accountData.data.investmentPools;
  }
  return [];
};

export const selectAmountAllocation = (state) => {
  const { grantAllocation } = fetchGAWState(state);
  if (
    grantAllocation &&
    grantAllocation.amountAllocation &&
    grantAllocation.amountAllocation.amount
  ) {
    return grantAllocation.amountAllocation.amount;
  }
  return '';
};

export const selectFundPool = (state) => {
  const { fundPool } = fetchGAWState(state);
  return fundPool;
};

export const selectGrantAllocationSelect = (state) => {
  const { grantAllocationSelect } = fetchGAWState(state);
  return grantAllocationSelect;
};

export const selectPayment = (state) => {
  const { grantAllocation } = fetchGAWState(state);
  if (
    grantAllocation &&
    grantAllocation.paymentComponent &&
    grantAllocation.paymentComponent.payment
  ) {
    return grantAllocation.paymentComponent.payment;
  }
  return [];
};

export const selectSelectedCharityEin = (state) => {
  const { selectedCharityEin } = fetchGAWState(state);
  return selectedCharityEin;
};

export const selectCharityId = (state) => {
  const { selectedCharityId } = fetchGAWState(state);
  return selectedCharityId;
};

export const selectIsSaveAgreementDone = (state) => {
  const { isSaveAgreementDone } = fetchGAWState(state);
  return isSaveAgreementDone;
};

export const editAndReviewDerivedStates = createStructuredSelector({
  data: selectAccountData,
  accountName: selectDataAccountName,
  selectedCharityAddress: selectEditAndReviewCharityAddress,
  selectedCharityName: selectEditAndReviewCharityName,
  granteeOrgFirstName: selectEditAndReviewGranteeOrgFirstName,
  granteeOrgLastName: selectEditAndReviewGranteeOrgLastName,
  granteeOrgEmailAddr: selectGranteeOrgEmailAddress,
  permissionToPublish: selectEditAndReviewPermissionToPublish,
  granteeOrgPhoneNumber: selectGranteeOrgPhoneNo,
  grantPurpose: selectPurpose,
  grantRecognition: selectGrantRecognition,
  investmentPools: selectInvestmentPools,
  grantAgreementAmount: selectAmountAllocation,
  fundPools: selectFundPool,
  payment: selectPayment,
  advisors: selectAdvisors,
  selectedCharityEin: selectSelectedCharityEin,
  selectedCharityId: selectCharityId,
  grantAllocationSelect: selectGrantAllocationSelect,
  agreement: selectIsSaveAgreementDone,
  codeValueMappingData: mapData,
  csrBusinessFunction: selectCsrBusinessFunction,
});
